const e={Base:"1rem",Lg:"1.5rem",Sm:"0.875rem",Xl:"2.25rem",Xxl:"3.75rem","2xl":"3.75rem"};export{e as TextSize};
